import React, { useEffect, useState } from "react";
import { HiPlus } from "react-icons/hi";
import { Link } from "react-router-dom";
import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
import { GiCheckMark, GiHamburgerMenu } from "react-icons/gi";
import { RxCross2 } from "react-icons/rx";
import { MdCampaign, MdOutlineCategory } from "react-icons/md";
import { BiNetworkChart, BiRadioCircle } from "react-icons/bi";
import { FiMonitor } from "react-icons/fi";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { TbDeviceTvOld } from "react-icons/tb";
import { BiVideo } from "react-icons/bi";
import { MdOutlinePushPin } from "react-icons/md";
import { CgNotes } from "react-icons/cg";
import { RiAdvertisementLine } from "react-icons/ri";
import { FiTarget } from "react-icons/fi";
import { TbTarget } from "react-icons/tb";
import { BiUser, BiGroup, BiGlobe, BiHome, BiTargetLock } from "react-icons/bi";
import {
  BiBuilding,
  BiBasket,
  BiCameraMovie,
  BiCar,
  BiChip,
  BiBookContent,
} from "react-icons/bi";
import { FiVideo, FiRefreshCw } from "react-icons/fi";
import { TbDeviceTv, TbDevices } from "react-icons/tb";
import { FiBell } from "react-icons/fi";
import { FaGraduationCap, FaEllipsisH } from "react-icons/fa";

import {
  MdCreditCard,
  MdOutlineAccountBalance,
  MdStarRate,
} from "react-icons/md";
import {
  BsCreditCard2BackFill,
  BsBank2,
  BsFillFuelPumpFill,
  BsFillGiftFill,
} from "react-icons/bs";
import { AiOutlineBank, AiOutlineGlobal } from "react-icons/ai";
import {
  FaPlaneDeparture,
  FaMoneyBillWave,
  FaRegSmileBeam,
} from "react-icons/fa";
import { HiOutlineBuildingLibrary } from "react-icons/hi2";
import { RiBankLine } from "react-icons/ri";
import { PiCardsBold } from "react-icons/pi";
import { TbTargetArrow, TbPigMoney } from "react-icons/tb";
import {
  FaCarCrash,
  FaMotorcycle,
  FaHeartbeat,
  FaUserShield,
} from "react-icons/fa";
import {
  FaCarSide,
  FaHome,
  FaUserTie,
  FaBookOpen,
  FaPiggyBank,
  FaBriefcase,
} from "react-icons/fa";
import { FaGift } from "react-icons/fa";
import { MdCardMembership } from "react-icons/md"; // Optional for lifestyle
const NavBarNew = () => {
  const [showSolution, setShowSolution] = useState(false);
  const [showResources, setShowResources] = useState(false);
  const [showResourcesNew, setShowResourcesNew] = useState(false);

  const [showBlogs, setShowBlogs] = useState(false);
  const [isNav, setIsNav] = useState(false);
  const [campaignWiseNav, setCampaignWiseNav] = useState(false);
  const [campaignWiseMobileNav, setCampaignWisemobileNav] = useState(false);

  const [displayNavbar, setDisplayNavbar] = useState(false);
  const [channelMobileNav, setChannelMobileNav] = useState(false);
  const [bestcardMobileNav, setBestCardMobileNav] = useState(false);
  const [caseStudyMobileNav, setCaseStudyMobileNav] = useState(false);
  const [caseStudyMobileNewNav, setCaseStudyMobileNewNav] = useState(false);

  const [targetingMobileNav, SetTargetingMobileNav] = useState(false);
  const [showBlogsNav, setShowBlogsNav] = useState(false);
  const [activeSection, setActiveSection] = useState(null);
  // const [activeSection, setActiveSection] = useState('Featured Card');

  const [backgroundColor, setBackgroundColor] = useState("white");
  // const navigation = navigator.platform.indexOf('Mac')

  // Function to handle scroll event
  const closeMobileNav = () => {
    setIsNav(false);
  };

  const NavLink = ({ to, children, className }) => {
    return (
      <Link
        to={to}
        onClick={closeMobileNav}
        className={className}
      >
        {children}
      </Link>
    );
  };
  const handleScroll = () => {
    if (window.scrollY > 30) {
      setBackgroundColor("white"); // Change background color to gradient when scrolled
    } else {
      setBackgroundColor("white"); // Reset background color when at the top
    }
  };
  const solutionsData = {
    "Top Categories": {
      icon: <MdStarRate className="w-5 h-5" />,
      items: [
        {
          name: "Fuel Card",
          icon: <BsFillFuelPumpFill className="w-4 h-4" />,
          path: "/credit-card/fuel-credit-card",
        },
        {
          name: "Travel Card",
          icon: <FaPlaneDeparture className="w-4 h-4" />,
          path: "/credit-card/travel-credit-card",
        },
        {
          name: "Premium Card",
          icon: <PiCardsBold className="w-4 h-4" />,
          path: "/credit-card/best-premium-credit-card",
        },
        {
          name: "Cash Back Card",
          icon: <FaMoneyBillWave className="w-4 h-4" />,
          path: "/credit-card/best-cashback-credit-card",
        },
        {
          name: "Lifetime Free Card",
          icon: <FaRegSmileBeam className="w-4 h-4" />,
          path: "/credit-card/best-lifetime-free-credit-cards",
        },

        {
          name: "Reward Credit Card",
          icon: <FaGift className="w-4 h-4" />,
          path: "/credit-card/reward-credit-card",
        },

        {
          name: "Business Credit Card",
          icon: <FaBriefcase  className="w-4 h-4" />,
          path: "/credit-card/business-credit-card",
        },
        {
          name: "LifeStyle Credit Card",
          icon: <MdCardMembership className="w-4 h-4" />,
          path: "/credit-card/lifestyle-credit-card",
        },
        
      ],
    },
    "Featured Card": {
      icon: <MdCreditCard className="w-5 h-5" />,
      items: [
        {
          name: "Credit Card",
          icon: <TbTargetArrow className="w-4 h-4" />,
          path: "/credit-card",
          // responsiveOnly: true, // optional helper
        },
        {
          name: " Au Bank Lit Credit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/aubank-credit-card",
        },
        {
          name: " Sbi SimplyClick Credit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/sbi-simplyclick-credit-card",
        },
        {
          name: "IDFC First ClassicCredit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/idfcfirst-classic-credit-card",
        },
        {
          name: "Flipkart Axis  Bank Credit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/axis-bank-flipkart-credit-card",
        },
        {
          name: "HDFC Bank Millennia Credit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/hdfc-bank/millennia-credit-card",
        },
        {
          name: "Eazy Diner Indusland Credit Card",
          icon: <BsCreditCard2BackFill className="w-4 h-4" />,
          path: "/credit-card/eazy-diner-indusind-bank-credit-card",
        },
      
      ],
    },
 
    "Bank Credit Card": {
      icon: <MdOutlineAccountBalance className="w-5 h-5" />,
      items: [
        {
          name: "AU BanK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/au-bank/credit-card",
        },
        {
          name: "SBI BANK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/sbi-bank/credit-card",
        },
        {
          name: "HDFC BANK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/hdfc-bank/credit-card",
        },
        {
          name: "IDFC BANK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/idfc-bank/credit-card",
        },
        {
          name: "Axis BANK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/axis-bank/credit-card",
        },
        {
          name: "ICICI BANK",
          icon: <RiBankLine className="w-4 h-4" />,
          path: "/icici-bank/credit-card",
        },
        {
          name: "Yes Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/yes-bank/credit-card",
        },
        {
          name: "HSBC bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/hsbc-bank/credit-card",
        },
        {
          name: " Induslnd Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/induslnd-bank/credit-card",
        },
        {
          name: "Bank Of Baroda ",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/bank-of-baroda/credit-card",
        },
        {
          name: "American Express ",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/american-bank/credit-card",
        },

        {
          name: "RBL Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/rbl-bank/credit-card",
        },
        {
          name: "PNB Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/punjab-national-bank/credit-card",
        },
        {
          name: "Union Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/union-bank/credit-card",
        },
        {
          name: "Canara Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/canara-bank/credit-card",
        },
        {
          name: "Bank of India",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/bank-of-india-bank/credit-card",
        },
        {
          name: "Federal Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/federal-bank/credit-card",
        },
        {
          name: "DBS Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: " /dbs-bank/credit-card",
        },
        {
          name: "Indian  Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/indian-bank/credit-card",
        },
        {
          name: "Ujjivan  Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/ujjivan-bank/credit-card",
        },
        {
          name: "Equitas  Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/equitas-bank/credit-card",
        },
        {
          name: "City Union Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/city-union-bank/credit-card",
        },
        {
          name: "South Indian Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/south-indian-bank/credit-card",
        },
        {
          name: "DCB Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/dcb-bank/credit-card",
        },
        {
          name: "J&K Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/jk-bank/credit-card",
        },
        {
          name: "KVB Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/karur-vysya-bank/credit-card",
        },
        {
          name: "Standard Charterned ",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/standard-bank/credit-card",
        },
        {
          name: "Kotak Mahindra Bank",
          icon: <AiOutlineBank className="w-4 h-4" />,
          path: "/kotak-mahindra-bank/credit-card",
        },
      ],
    },
    // 'Other Banks': {
    //   icon: <HiOutlineBuildingLibrary className="w-5 h-5" />,
    //   items: [
    //     { name: 'Kotak Mahindra Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/kotak-mahindra-bank/credit-card' },
    //     { name: 'RBL Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/rbl-bank/credit-card' },
    //     { name: 'PNB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/punjab-national-bank/credit-card' },
    //     { name: 'Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/union-bank/credit-card' },
    //     { name: 'Canara Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/canara-bank/credit-card' },
    //     { name: 'Bank of India', icon: <AiOutlineBank className="w-4 h-4" />, path: '/bank-of-india-bank/credit-card' },
    //     { name: 'Federal Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/federal-bank/credit-card' },
    //     { name: 'DBS Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: ' /dbs-bank/credit-card' },
    //     { name: 'Indian  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/indian-bank/credit-card' },
    //     { name: 'Ujjivan  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/ujjivan-bank/credit-card' },
    //     { name: 'Equitas  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/equitas-bank/credit-card' },
    //     { name: 'City Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/city-union-bank/credit-card' },
    //     { name: 'South Indian Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/south-indian-bank/credit-card' },
    //     { name: 'DCB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/dcb-bank/credit-card' },
    //     { name: 'J&K Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/jk-bank/credit-card' },
    //     { name: 'KVB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/karur-vysya-bank/credit-card' },

    //   ]
    // },
  };
  // Add event listener when the component mounts
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    // Remove event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const navbarStyle = {
    background: backgroundColor,
    transition: "background-color 0.3s ease", // Adjust the duration as needed
  };
  const handleDropdownToggle = () => {
    setShowSolution(prev => {
      if (!prev) {
        setActiveSection('Featured Card');
      }
      return !prev;
    });
  };
  return (
    <>
        {isNav && (
        <div className="fixed top-0 left-0 right-0 bottom-0 z-50 bg-gradient-to-r from-purple-600 to-blue-600 overflow-y-auto">
          <div className="w-full flex justify-end p-4">
            <button
              onClick={closeMobileNav}
              className="text-white p-2"
            >
              <RxCross2 size={24} />
            </button>
          </div>
       

          <div className="w-full px-4 pt-4">
            
            <ul className="text-white font-medium space-y-4">
              <li onClick={() => setShowSolution(!showSolution)} className="cursor-pointer">

                <div className="flex items-center justify-between">
                  <span>CREDIT CARDS</span>
                  {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
                </div>
                
                {showSolution && (
                  <div className="mt-2 space-y-2 max-h-[60vh] overflow-y-auto">
                    {Object.entries(solutionsData).map(([section, data]) => (
                      <div key={section} className="mb-2">
                        <div 
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveSection(activeSection === section ? null : section);
                          }}
                          className={`flex items-center justify-between p-2 ${
                            activeSection === section ? 'bg-white/20' : 'bg-white/10'
                          } rounded`}
                        >
                          <span className="flex items-center gap-2">
                            {data.icon}
                            {section}
                          </span>
                          {activeSection === section ? <AiFillCaretUp /> : <AiFillCaretDown />}
                        </div>
                        
                        {activeSection === section && (
                          <div className="mt-2 pl-4 space-y-2">
                            {data.items.map((item) => (
                              <NavLink 
                                key={item.path} 
                                to={item.path}
                                className="flex items-center gap-2 p-2 hover:bg-white/10 rounded"
                              >
                                {item.icon}
                                <span>{item.name}</span>
                              </NavLink>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </li>

              {/* Insurance Section */}
              <li onClick={() => setShowResources(!showResources)} className="cursor-pointer">
                <div className="flex items-center justify-between">
                  <span>INSURANCE</span>
                  {showResources ? <AiFillCaretUp /> : <AiFillCaretDown />}
                </div>
                
                {showResources && (
                  <div className="mt-2 space-y-2">
                     <NavLink to="/insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaCarCrash />
                      <span>Insurance</span>
                    </NavLink>
                    <NavLink to="/car_insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaCarCrash />
                      <span>Car Insurance</span>
                    </NavLink>
                    <NavLink to="/bike_insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaMotorcycle />
                      <span>Bike Insurance</span>
                    </NavLink>
                    <NavLink to="/travel_insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaPlaneDeparture />
                      <span>Travel Insurance</span>
                    </NavLink>
                    <NavLink to="/health_insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaHeartbeat />
                      <span>Health Insurance</span>
                    </NavLink>
                    <NavLink to="/termlife_insurance" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaUserShield />
                      <span>Term Life Insurance</span>
                    </NavLink>
                  </div>
                )}
              </li>

              {/* Get Loan Section */}
              <li onClick={() => setShowResourcesNew(!showResourcesNew)} className="cursor-pointer">
                <div className="flex items-center justify-between">
                  <span>GET LOAN</span>
                  {showResourcesNew ? <AiFillCaretUp /> : <AiFillCaretDown />}
                </div>
                
                {showResourcesNew && (
                  <div className="mt-2 space-y-2">
                    <NavLink to="/loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaCarSide />
                      <span>Loan</span>
                    </NavLink>
                    <NavLink to="/car_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaCarSide />
                      <span>Car Loan</span>
                    </NavLink>
                    <NavLink to="/home_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaHome />
                      <span>Home Loan</span>
                    </NavLink>

                    <NavLink to="/gold_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaPiggyBank />
                      <span>Gold Loan</span>
                    </NavLink>
                    <NavLink to="/business_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaBriefcase />
                      <span>Business Loan</span>
                    </NavLink>
                    <NavLink to="/personal_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaUserTie />
                      <span>Personal Loan</span>
                    </NavLink>
                    <NavLink to="/education_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaBookOpen />
                      <span>Education Loan</span>
                    </NavLink>
                    <NavLink to="/two_wheeler_loan" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <FaMotorcycle  />
                      <span>TwoWheeler Loan</span>
                    </NavLink>
                  </div>
                )}
              </li>

              {/* Other Navigation Items */}
              <li>
                <NavLink to="/demat" className="block hover:bg-white/10 rounded  ">DEMAT </NavLink>
              </li>
              
              <li onClick={() => setShowBlogs(!showBlogs)} className="cursor-pointer">
                <div className="flex items-center justify-between">
                  <span>RESOURCES</span>
                  {showBlogs ? <AiFillCaretUp /> : <AiFillCaretDown />}
                </div>
                
                {showBlogs && (
                  <div className="mt-2">
                    <NavLink to="/blog" className="flex items-center gap-2 p-2 hover:bg-white/10 rounded">
                      <BiBookContent />
                      <span>Blogs</span>
                    </NavLink>
                  </div>
                )}
              </li>

              <li>
                <NavLink to="/financial-tools-calculators" className="block hover:bg-white/10 rounded ">TOOLS</NavLink>
              </li>
              
              <li>
                <NavLink to="/contact-us" className="block hover:bg-white/10 rounded ">CONTACT US</NavLink>
              </li>
            </ul>
          </div>
        </div>
      )}
      <div
        style={navbarStyle}
        className="w-full fixed top-0 z-50 flex flex-col items-center"
          // className="w-full z-50 bg-white sticky top-0  flex justify-center"
    >
       <div className="w-full px-2 sm:px-4 md:w-[95%] md:px-0 caption py-3 flex justify-between items-center">
          {/* Logo Section - Fixed alignment */}
          <a href="/" className="flex-shrink-0">
            <div className="flex items-center">
              <img
                className="h-8 sm:h-9 md:h-10 w-auto object-contain"
                src="/1logo.png"
                alt="TheFinMaster Logo"
              />
            </div>
          </a>
        {/* <div className="w-[95%] caption py-3 flex justify-between">
          <a href="/">
            <div className="text-white w-18 h-10 z-20">
              <img
                className={" h-10 w-[15rem] object-fill "}
                src="/1logo.png"
                alt="logo"
              />
            </div>
          </a> */}
          {/* <a href='/'>
                    <div className='hidden md:block text-white w-18 h-10 z-20'>
                <img className='w-[100%] h-[100%] object-fill' src='/logo1.jpg' alt='B Logo' />
            </div>
            <div className='block md:hidden text-white w-18 h-10 z-20'>
                <img className='w-[100%] h-[100%] object-fill' src='/b.jpeg' alt='Logo' />
            </div>
</a> */}
          <ul
            className={`hidden text-white font-medium md:flex gap-12 md:items-center mr-4 mt-2`}
          >
            {/*          
            <li
              onMouseEnter={() => setShowSolution(true)}
              onMouseLeave={() => setShowSolution(false)}
              className="relative cursor-pointer flex items-center gap-1 text-black"
            >
              CREDIT CARDS {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
              {showSolution && (
                <div className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[950px] shadow-lg py-6 border left-0">
                  <div className="grid grid-cols-4 gap-6 p-6">
                    <div className="col-span-1 border-r pr-4">
                      {Object.keys(solutionsData).map((section) => (
                        <div
                          key={section}
                          onMouseEnter={() => setActiveSection(section)}
                          className={`px-4 py-2 cursor-pointer rounded-lg transition-all flex items-center gap-2 ${
                            activeSection === section
                              // ? "bg-blue-50 text-blue-600"
                              // : "hover:bg-gray-50"
                              ? "bg-[#217dd3] text-white shadow-md"
                  : "hover:bg-gray-100 hover:text-[#217dd3]"
                          }`}
                        >
                          {solutionsData[section].icon}
                          {section}
                        </div>
                      ))}
                    </div>

                    <div className="col-span-3 pl-4">
                      {activeSection && (
                        <div className="grid grid-cols-2 gap-4">
                          {solutionsData[activeSection].items.map((item) => (
                            <a
                              key={item.name}
                              href={item.path}
                              className="p-3 rounded-lg hover:bg-gray-50  hover:shadow-md   transition-all"
                            >
                              <div className="font-medium textColor flex items-center  gap-2">
                                {item.icon}
                                {item.name}
                              </div>
                              <p className="text-sm text-gray-500 mt-1 ml-6">
                                Explore our {item.name.toLowerCase()} 
                              </p>
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </li> */}
            <li
              onMouseEnter={() => setShowSolution(true)}
              onMouseLeave={() => setShowSolution(false)}
              className="relative cursor-pointer flex items-center gap-1 text-black"
            >
              <Link to="/credit-card">CREDIT CARDS</Link>{" "}
              {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
              {showSolution && (
                <div className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[960px] shadow-lg py-6 border left-0">
                  <div className="grid grid-cols-5 gap-6 p-6">
                    <div className="col-span-1 border-r pr-4">
                      {Object.keys(solutionsData).map((section) => (
                        <div
                          key={section}
                          onMouseEnter={() => setActiveSection(section)}
                          className={`px-1 py-2 cursor-pointer rounded-lg transition-all flex items-center gap-2 ${
                            activeSection === section
                              ? "bg-[#217dd3] text-white shadow-md"
                              : "hover:bg-gray-100 hover:text-[#217dd3]"
                          }`}
                        >
                          {solutionsData[section].icon}
                          {section}
                        </div>
                      ))}
                    </div>

                    <div className="col-span-4 pl-4">
                      {activeSection && (
                        <div className="grid grid-cols-4 gap-3">
                          {/* {solutionsData[activeSection].items.map((item) => ( */}
                          {solutionsData[activeSection].items
  .filter((item) => item.name !== "Credit Card") // hide on desktop
  .map((item) => (
                            <a
                              key={item.name}
                              href={item.path}
                              className="p-2 rounded-lg hover:bg-gray-50 hover:shadow-md transition-all flex flex-col"
                            >
                              <div className="font-medium textColor flex items-center gap-2 text-sm">
                                {item.icon}
                                {item.name}
                              </div>
                              {/* <p className="text-xs text-gray-500 mt-1 ml-6">
                    Explore our {item.name.toLowerCase().replace("bank", "").trim()} 
                  </p> */}
                            </a>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </li>
            <li
              onMouseOver={() => setShowResources(true)}
              onMouseLeave={() => setShowResources(false)}
              className="relative cursor-pointer flex items-center gap-1 text-black"
            >
            <Link to="/insurance">  INSURANCE{" "}</Link> 
              {showResources ? <AiFillCaretUp /> : <AiFillCaretDown />}
              {showResources && (
                <>
                  <div
                    onMouseOver={() => setShowResources(true)}
                    className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
                  >
                    <a href="/car_insurance">
                      <p className="whitespace-nowrap font-medium text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaCarCrash />
                        Car Insurance
                      </p>
                    </a>
                    <a href="/bike_insurance">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaMotorcycle />
                        Bike Insurance
                      </p>
                    </a>
                    <a href="/travel_insurance">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaPlaneDeparture />
                        Travel Insurance
                      </p>
                    </a>
                    <a href="/health_insurance">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaHeartbeat />
                        Health Insurance
                      </p>
                    </a>
                    <a href="/termlife_insurance">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <BiUser />
                        Term Life Insurance
                      </p>
                    </a>
                  </div>
                </>
              )}
            </li>
            <li
              onMouseOver={() => setShowResourcesNew(true)}
              onMouseLeave={() => setShowResourcesNew(false)}
              className="relative cursor-pointer flex items-center gap-1 text-black"
            >
             <Link to="/loan">   GET LOAN{" "}</Link>
              {showResourcesNew ? <AiFillCaretUp /> : <AiFillCaretDown />}
              {showResourcesNew && (
                <>
                  <div
                    onMouseOver={() => setShowResourcesNew(true)}
                    className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
                  >
                    <a href="/car_loan">
                      <p className="whitespace-nowrap font-medium text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaCarSide />
                        Car Loan
                      </p>
                    </a>
                    <a href="/gold_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaPiggyBank />
                        Gold Loan
                      </p>
                    </a>
                    <a href="/home_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaHome />
                        Home Loan
                      </p>
                    </a>
                    <a href="/personal_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaUserTie />
                        Personal Loan
                      </p>
                    </a>
                    <a href="/business_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaBriefcase />
                        Business Loan
                      </p>
                    </a>

                    <a href="/education_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaBookOpen />
                        Education Loan
                      </p>
                    </a>
                    <a href="/two_wheeler_loan">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <FaMotorcycle />
                        TwoWheeler Loan
                      </p>
                    </a>
                  </div>
                </>
              )}
            </li>
            <a href="/demat">
              <li className="relative cursor-pointer text-black"> DEMAT</li>
            </a>
            <li
              onMouseOver={() => setShowBlogs(true)}
              onMouseLeave={() => setShowBlogs(false)}
              className="relative cursor-pointer flex items-center gap-1 text-black"
            >
              RESOURCES {showBlogs ? <AiFillCaretUp /> : <AiFillCaretDown />}
              {showBlogs && (
                <>
                  <div
                    onMouseOver={() => setShowBlogs(true)}
                    className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
                  >
                    <a href="/blog">
                      <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
                        <BiBookContent />
                        Blogs
                      </p>
                    </a>
                  </div>
                </>
              )}
            </li>

            <a href="/financial-tools-calculators">
              <li className="relative cursor-pointer text-black"> TOOLS</li>
            </a>
            <a href="/contact-us">
              <li className="relative cursor-pointer text-black">CONTACT US</li>
            </a>
          </ul>

          <div className="flex items-center md:hidden">
            {isNav ? (
              <RxCross2
                className="text-black text-2xl cursor-pointer"
                onClick={() => setIsNav((prev) => !prev)}
              />
            ) : (
              <GiHamburgerMenu
                onClick={() => setIsNav((prev) => !prev)}
                className="text-black text-2xl cursor-pointer"
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NavBarNew;


// import React, { useEffect, useState } from "react";
// import { HiPlus } from "react-icons/hi";
// import { Link } from "react-router-dom";
// import { AiFillCaretDown, AiFillCaretUp } from "react-icons/ai";
// import { GiCheckMark, GiHamburgerMenu } from "react-icons/gi";
// import { RxCross2 } from "react-icons/rx";
// import { MdCampaign, MdOutlineCategory } from "react-icons/md";
// import { BiNetworkChart, BiRadioCircle } from "react-icons/bi";
// import { FiMonitor } from "react-icons/fi";
// import { IoPhonePortraitOutline } from "react-icons/io5";
// import { TbDeviceTvOld } from "react-icons/tb";
// import { BiVideo } from "react-icons/bi";
// import { MdOutlinePushPin } from "react-icons/md";
// import { CgNotes } from "react-icons/cg";
// import { RiAdvertisementLine } from "react-icons/ri";
// import { FiTarget } from "react-icons/fi";
// import { TbTarget } from "react-icons/tb";
// import {  BiUser, BiGroup, BiGlobe, BiHome, BiTargetLock } from "react-icons/bi";
// import { BiBuilding, BiBasket, BiCameraMovie, BiCar,  BiChip, BiBookContent } from "react-icons/bi";
// import { FiVideo, FiRefreshCw } from "react-icons/fi";
// import { TbDeviceTv, TbDevices } from "react-icons/tb";
// import {  FiBell } from "react-icons/fi";
// import { FaGraduationCap, FaEllipsisH } from "react-icons/fa";

// import { MdCreditCard, MdOutlineAccountBalance, MdStarRate } from "react-icons/md";
// import { BsCreditCard2BackFill, BsBank2, BsFillFuelPumpFill, BsFillGiftFill } from "react-icons/bs";
// import { AiOutlineBank, AiOutlineGlobal } from "react-icons/ai";
// import { FaPlaneDeparture, FaMoneyBillWave, FaRegSmileBeam } from "react-icons/fa";
// import { HiOutlineBuildingLibrary } from "react-icons/hi2";
// import { RiBankLine } from "react-icons/ri";
// import { PiCardsBold } from "react-icons/pi";
// import { TbTargetArrow, TbPigMoney } from "react-icons/tb";
// import { FaCarCrash, FaMotorcycle,  FaHeartbeat, FaUserShield } from "react-icons/fa";
// import {
//     FaCarSide,
//     FaHome,
//     FaUserTie,
//     FaBookOpen,
//     FaPiggyBank,
//     FaBriefcase
//   } from "react-icons/fa";
// const NavBarNew = () => {
//   const [showSolution, setShowSolution] = useState(false);
//   const [showResources, setShowResources] = useState(false);
//   const [showResourcesNew, setShowResourcesNew] = useState(false);

//   const [showBlogs, setShowBlogs] = useState(false);
//   const [isNav, setIsNav] = useState(false);
//   const [campaignWiseNav, setCampaignWiseNav] = useState(false);
//   const [campaignWiseMobileNav, setCampaignWisemobileNav] = useState(false);
  
//   const [displayNavbar, setDisplayNavbar] = useState(false);
//   const [channelMobileNav, setChannelMobileNav] = useState(false);
//   const [bestcardMobileNav, setBestCardMobileNav] = useState(false);
//   const [caseStudyMobileNav, setCaseStudyMobileNav] = useState(false);
//   const [caseStudyMobileNewNav, setCaseStudyMobileNewNav] = useState(false);

//   const [targetingMobileNav, SetTargetingMobileNav] = useState(false);
//   const [showBlogsNav, setShowBlogsNav] = useState(false);
//   const [activeSection, setActiveSection] = useState(null);

//   const [backgroundColor, setBackgroundColor] = useState("white");
//   // const navigation = navigator.platform.indexOf('Mac')

//   // Function to handle scroll event
//   const handleScroll = () => {
//     if (window.scrollY > 30) {
//       setBackgroundColor("white"); // Change background color to gradient when scrolled
//     } else {
//       setBackgroundColor("white"); // Reset background color when at the top
//     }
//   };
//   const solutionsData = {
//     'Featured Card': {
//       icon: <MdCreditCard className="w-5 h-5" />,
//       items: [
//         { name: ' Au Bank Lit Credit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/aubank-credit-card' },
//         { name: ' Sbi SimplyClick Credit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/sbi-simplyclick-credit-card' },
//         { name: 'IDFC First ClassicCredit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/idfcfirst-classic-credit-card' },
//         { name: 'Flipkart Axis  Bank Credit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/axis-bank-flipkart-credit-card' },
//         { name: 'HDFC Bank Millennia Credit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/hdfc-bank/millennia-credit-card' },
//         { name: 'Eazy Diner Indusland Credit Card', icon: <BsCreditCard2BackFill className="w-4 h-4" />, path: '/credit-card/eazy-diner-indusind-bank-credit-card' },
//         { name: 'Credit Card', icon: <TbTargetArrow className="w-4 h-4" />, path: '/credit-card' },

//     ]
//     },
//     'Best Cards': {
//       icon: <MdStarRate className="w-5 h-5" />,
//       items: [
//         { name: 'Fuel Card', icon: <BsFillFuelPumpFill className="w-4 h-4" />, path: '/credit-card/fuel-credit-card' },
//          { name: 'Travel Card', icon: <FaPlaneDeparture className="w-4 h-4" />, path: '/credit-card/travel-credit-card' },
//      { name: 'Premium Card', icon: <PiCardsBold className="w-4 h-4" />, path: '/credit-card/best-premium-credit-card' },
//          { name: 'Cash Back Card', icon: <FaMoneyBillWave className="w-4 h-4" />, path: '/credit-card/best-cashback-credit-card' },
//          { name: 'Lifetime Free Card', icon: <FaRegSmileBeam className="w-4 h-4" />, path: '/credit-card/best-lifetime-free-credit-cards' },

//       ]
//     },
//     'Bank Credit Card': {
//       icon: <MdOutlineAccountBalance className="w-5 h-5" />,
//       items: [
//         { name: 'AU BanK', icon: <RiBankLine className="w-4 h-4" />, path: '/au-bank/credit-card' },
//         { name: 'SBI BANK', icon: <RiBankLine className="w-4 h-4" />, path: '/sbi-bank/credit-card' },
//     { name: 'HDFC BANK', icon: <RiBankLine className="w-4 h-4" />, path: '/hdfc-bank/credit-card' },
//         { name: 'IDFC BANK', icon: <RiBankLine className="w-4 h-4" />, path: '/idfc-bank/credit-card' },
//         { name: 'Axis BANK', icon: <RiBankLine className="w-4 h-4" />, path: '/axis-bank/credit-card' },
//        { name: 'ICICI BANK', icon: <RiBankLine className="w-4 h-4" />, path: '/icici-bank/credit-card' },
//         { name: 'Yes Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/yes-bank/credit-card' },
//         { name: 'HSBC bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/hsbc-bank/credit-card' },
//         { name: ' Induslnd Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/induslnd-bank/credit-card' },
//         { name: 'Bank Of Baroda ', icon: <AiOutlineBank className="w-4 h-4" />, path: '/bank-of-baroda/credit-card' },
//          { name: 'American Express ', icon: <AiOutlineBank className="w-4 h-4" />, path: '/american-bank/credit-card' },
         
//         { name: 'RBL Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/rbl-bank/credit-card' },
//         { name: 'PNB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/punjab-national-bank/credit-card' },
//         { name: 'Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/union-bank/credit-card' },
//         { name: 'Canara Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/canara-bank/credit-card' },
//         { name: 'Bank of India', icon: <AiOutlineBank className="w-4 h-4" />, path: '/bank-of-india-bank/credit-card' },
//         { name: 'Federal Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/federal-bank/credit-card' },
//         { name: 'DBS Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: ' /dbs-bank/credit-card' },
//         { name: 'Indian  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/indian-bank/credit-card' },
//         { name: 'Ujjivan  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/ujjivan-bank/credit-card' },
//         { name: 'Equitas  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/equitas-bank/credit-card' },
//         { name: 'City Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/city-union-bank/credit-card' },
//         { name: 'South Indian Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/south-indian-bank/credit-card' },
//         { name: 'DCB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/dcb-bank/credit-card' },
//         { name: 'J&K Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/jk-bank/credit-card' },
//         { name: 'KVB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/karur-vysya-bank/credit-card' },
//         { name: 'Standard Charterned ', icon: <AiOutlineBank className="w-4 h-4" />, path: '/standard-bank/credit-card' },
//          { name: 'Kotak Mahindra Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/kotak-mahindra-bank/credit-card' },
//       ]
//     },
//     // 'Other Banks': {
//     //   icon: <HiOutlineBuildingLibrary className="w-5 h-5" />,
//     //   items: [
//     //     { name: 'Kotak Mahindra Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/kotak-mahindra-bank/credit-card' },
//     //     { name: 'RBL Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/rbl-bank/credit-card' },
//     //     { name: 'PNB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/punjab-national-bank/credit-card' },
//     //     { name: 'Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/union-bank/credit-card' },
//     //     { name: 'Canara Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/canara-bank/credit-card' },
//     //     { name: 'Bank of India', icon: <AiOutlineBank className="w-4 h-4" />, path: '/bank-of-india-bank/credit-card' },
//     //     { name: 'Federal Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/federal-bank/credit-card' },
//     //     { name: 'DBS Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: ' /dbs-bank/credit-card' },
//     //     { name: 'Indian  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/indian-bank/credit-card' },
//     //     { name: 'Ujjivan  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/ujjivan-bank/credit-card' },
//     //     { name: 'Equitas  Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/equitas-bank/credit-card' },
//     //     { name: 'City Union Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/city-union-bank/credit-card' },
//     //     { name: 'South Indian Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/south-indian-bank/credit-card' },
//     //     { name: 'DCB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/dcb-bank/credit-card' },
//     //     { name: 'J&K Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/jk-bank/credit-card' },
//     //     { name: 'KVB Bank', icon: <AiOutlineBank className="w-4 h-4" />, path: '/karur-vysya-bank/credit-card' },

//     //   ]
//     // },
    
//   };
//   // Add event listener when the component mounts
//   useEffect(() => {
//     window.addEventListener("scroll", handleScroll);

//     // Remove event listener when the component unmounts
//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, []);
//   const navbarStyle = {
//     background: backgroundColor,
//     transition: "background-color 0.3s ease", // Adjust the duration as needed
//   };

//   return (
//     <>
//       {isNav && (
//         <>
//           <div className="fixed top-0 flex justify-center z-50 w-full  bg-gradient-to-r from-purple-600 to-blue-600">
//             <div className="w-[95%] mt-20 flex justify-between">
//               <ul className="text-white font-medium flex py-5 overflow-scroll flex-col gap-5">
//                 <li
//                   onClick={() => setShowSolution((prev) => !prev)}
//                   className="relative cursor-pointer flex items-center gap-1"
//                 >
//                    FEATURED CARD{" "}
//                   {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
//                 </li>
//                 {showSolution && (
//                   <>
//                     {" "}
//                     <li>
//                       <p
//                         onClick={() =>
//                           setCampaignWisemobileNav((prev) => !prev)
//                         }
//                         className={`whitespace-nowrap ${
//                           campaignWiseMobileNav && "font-medium"
//                         } text-white py-2 px-5 flex items-center gap-2`}
//                       >
//                         {campaignWiseMobileNav ? (
//                           <RxCross2 className="text-xl" />
//                         ) : (
//                           <HiPlus className="text-xl" />
//                         )}{" "}
//                      Featured Credit Card
                  
//                       </p>

//                       {campaignWiseMobileNav && (
//                         <>
//                           <a href="/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <TbTargetArrow />
//                               Credit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/aubank-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsCreditCard2BackFill />
//                               Au Bank Lit Credit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/sbi-simplyclick-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsCreditCard2BackFill />
//                               Sbi SimplyClick Credit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/idfcfirst-classic-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                             <BsCreditCard2BackFill />
//                               IDFC First ClassicCredit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/axis-bank-flipkart-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsCreditCard2BackFill />
//                               Flipkart Axis  Bank Credit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/axis-bank-flipkart-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsCreditCard2BackFill />
//                               HDFC Bank Millennia Credit Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/eazy-diner-indusind-bank-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsCreditCard2BackFill />
//                               Eazy Diner Indusland Credit Card
//                             </p>
//                           </a>
//                         </>
//                       )}

//                       <p
//                         onClick={() => setChannelMobileNav((prev) => !prev)}
//                         className={`whitespace-nowrap ${
//                           channelMobileNav && "font-medium"
//                         } text-white py-2 px-5 flex items-center gap-2`}
//                       >
//                         {channelMobileNav ? (
//                           <RxCross2 className="text-xl" />
//                         ) : (
//                           <HiPlus className="text-xl" />
//                         )}{" "}
//                         Best Cards
//                       </p>
//                       {channelMobileNav && (
//                         <>
//                           <a href="/credit-card/fuel-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#00308F] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <BsFillFuelPumpFill />
//                               Fuel Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/travel-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#00308F] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <FaPlaneDeparture />
//                               Travel Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/best-premium-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#00308F] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <PiCardsBold />
//                               Premium Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/best-cashback-credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#00308F] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <FaMoneyBillWave />
//                               Cash Back Card
//                             </p>
//                           </a>
//                           <a href="/credit-card/best-lifetime-free-credit-cards">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#00308F] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <FaRegSmileBeam />
//                               Lifetime Free Card
//                             </p>
//                           </a>
                    
                          
//                         </>
//                       )}
                      
//                       <p
//                         onClick={() => setBestCardMobileNav((prev) => !prev)}
//                         className={`whitespace-nowrap ${
//                             bestcardMobileNav && "font-medium"
//                         } text-white py-2 px-5 flex items-center gap-2`}
//                       >
//                         {bestcardMobileNav ? (
//                           <RxCross2 className="text-xl" />
//                         ) : (
//                           <HiPlus className="text-xl" />
//                         )}{" "}
//                         Bank Credit Card
//                       </p>
//                       {bestcardMobileNav && (
//                         <>

// <a href="/au-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               AU BanK
//                             </p>
//                           </a>
//                           <a href="/sbi-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               SBI BANK
//                             </p>
//                           </a>
//                           <a href="/hdfc-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               HDFC BANK
//                             </p>
//                           </a>
//                           <a href="/idfc-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               IDFC BANK
//                             </p>
//                           </a>
//                           <a href="/axis-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               Axis BANK
//                             </p>
//                           </a>
//                           <a href="/icici-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <RiBankLine />
//                               ICICI BANK
//                             </p>
//                           </a>
//                           <a href="/yes-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Yes Bank
//                             </p>
//                           </a>
//                           <a href="/hsbc-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Hsbc bank
//                             </p>
//                           </a>
//                           <a href="/induslnd-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Indusland Bank
//                             </p>
//                           </a>
//                           <a href="/bank-of-baroda/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Bank Of Baroda Bank
//                             </p>
//                           </a>
//                           <a href="/standard-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Standard Charterned Bank
//                             </p>
//                           </a>
//                           <a href="/american-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               American Express Bank Bank
//                             </p>
//                           </a>
                        
                        
//                         </>
//                       )}
//                        <p
//                         onClick={() => SetTargetingMobileNav((prev) => !prev)}
//                         className={`whitespace-nowrap ${
//                           targetingMobileNav && "font-medium"
//                         } text-white py-2 px-5 flex items-center gap-2`}
//                       >
//                         {targetingMobileNav ? (
//                           <RxCross2 className="text-xl" />
//                         ) : (
//                           <HiPlus className="text-xl" />
//                         )}{" "}
//                       Other Banks
//                       </p>

//                       {targetingMobileNav && (
//                         <>
//                             <a href="/kotak-mahindra-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-1 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Kotak Mahindra Bank
//                             </p>
//                           </a>

//                           <a href="/rbl-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               RBL Bank
//                             </p>
//                           </a> 
//                           <a href="/punjab-national-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               PNB Bank
//                             </p>
//                           </a>
//                           <a href="/union-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Union Bank
//                             </p>
//                           </a>
//                           <a href="/canara-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Canara Bank
//                             </p>
//                           </a>
//                           <a href="/bank-of-india-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Bank of India
//                             </p>
//                           </a>
//                           <a href="/federal-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Federal Bank
//                             </p>
//                           </a>
//                           <a href="/dbs-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               DBS Bank
//                             </p>
//                           </a>
//                           <a href="/indian-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Indian Bank
//                             </p>
//                           </a>
//                           <a href="/ujjivan-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               'Ujjivan  Bank
//                             </p>
//                           </a>
//                           <a href="/equitas-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               Equitas  Bank
//                             </p>
//                           </a>
//                           <a href="/city-union-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               City Union Bank
//                             </p>
//                           </a>
//                           <a href="/south-indian-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               South Indian Bank
//                             </p>
//                           </a>
//                           <a href="/dcb-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               DCB Bank
//                             </p>
//                           </a>
//                           <a href="/jk-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               J&K Bank
//                             </p>
//                           </a>
//                           <a href="/karur-vysya-bank/credit-card">
//                             <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3 ml-7">
//                               <AiOutlineBank />
//                               KVB Bank
//                             </p>
//                           </a>
                       
//                         </>
//                       )} 
                     
//                     </li>
//                   </>
//                 )}

//                 <li
//                   onClick={() => setCaseStudyMobileNav((prev) => !prev)}
//                   className="relative cursor-pointer flex items-center gap-1"
//                 >
//                   <a className="flex items-center gap-1">
//                   INSURANCE{" "}
//                     {caseStudyMobileNav ? (
//                       <AiFillCaretUp />
//                     ) : (
//                       <AiFillCaretDown />
//                     )}
//                   </a>
//                 </li>
//                 {caseStudyMobileNav && (
//                   <li>
//                     <div>
//                       <a href="/car_insurance">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaCarCrash  />
//                         Car Insurance
//                         </p>
//                       </a>
//                       <a href="/bike_insurance">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaMotorcycle  />
//                         Bike Insurance
//                         </p>
//                       </a>
//                       <a href="/travel_insurance">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaPlaneDeparture />
//                         Travel Insurance
//                         </p>
//                       </a>
//                       <a href="/health_insurance">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaHeartbeat />
//                         Health Insurance
//                         </p>
//                       </a>
//                       <a href="/termlife_insurance">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaUserShield/>
//                         Term Life Insurance
//                         </p>
//                       </a>
                     
                     
//                     </div>
//                   </li>
//                 )}
//                    <li
//                   onClick={() => setCaseStudyMobileNewNav((prev) => !prev)}
//                   className="relative cursor-pointer flex items-center gap-1"
//                 >
//                   <a className="flex items-center gap-1">
//                   GET LOAN{" "}
//                     {caseStudyMobileNewNav ? (
//                       <AiFillCaretUp />
//                     ) : (
//                       <AiFillCaretDown />
//                     )}
//                   </a>
//                 </li>
//                 {caseStudyMobileNewNav && (
//                   <li>
//                     <div>
//                       <a href="/car_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaCarSide />
//                         Car Loan
//                         </p>
//                       </a>
//                       <a href="/home_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaHome />
//                         Home Loan
//                         </p>
//                       </a>
//                       <a href="/personal_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaUserTie />
//                         Personal Loan
//                         </p>
//                       </a>
//                       <a href="/education_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaBookOpen  />
//                         Education Loan
//                         </p>
//                       </a>
//                       <a href="/two_wheeler_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaMotorcycle />
//                         TwoWheeler Loan
//                         </p>
//                       </a>
//                       <a href="/gold_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaPiggyBank />
//                         Gold Loan
//                         </p>
//                       </a>
//                       <a href="/business_loan">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <FaBriefcase />
//                         Business Loan
//                         </p>
//                       </a>
                     
//                     </div>
//                   </li>
//                 )}
//                 <a href="/demat">
//                   <li className="relative cursor-pointer"> DEMAT</li>
//                 </a>
               
//                 <li
//                   onClick={() => setShowBlogsNav((prev) => !prev)}
//                   className="relative cursor-pointer flex items-center gap-1"
//                 >
//                   <a className="flex items-center gap-1">
//                     RESOURCES{" "}
//                     {showBlogsNav ? <AiFillCaretUp /> : <AiFillCaretDown />}
//                   </a>
//                 </li>
//                 {showBlogsNav && (
//                   <li>
//                     <div>
//                       <a href="/blog_page">
//                         <p className="whitespace-nowrap text-white py-2 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                         <BiBookContent/>
//                           Blogs
//                         </p>
//                       </a>
                    
                    
//                     </div>
//                   </li>
//                 )}
//   <a href="/financial-tools-calculators">
//                   <li className="relative cursor-pointer"> TOOLS</li>
//                 </a>
//                 {/* <a href="/about">
//                   <li className="relative cursor-pointer">ABOUT US</li>
//                 </a> */}
//                 <a href="/contact-us">
//                   <li className="relative cursor-pointer">CONTACT US</li>
//                 </a>
//               </ul>
//             </div>
//           </div>
//         </>
//       )}

//       <div
//         style={navbarStyle}
//         className="w-full fixed top-0 z-50 flex flex-col items-center"
//       >
//         <div className="w-[95%] caption py-3 flex justify-between">
//           <a href="/">
//             <div className="text-white w-18 h-10 z-20">
//               <img
//                 className={" h-12 w-[14rem] object-fill "}
//                 src="/1logo.png"
//                 alt="logo"
//               />
//             </div>
//           </a>
//           {/* <a href='/'>
//                     <div className='hidden md:block text-white w-18 h-10 z-20'>
//                 <img className='w-[100%] h-[100%] object-fill' src='/logo1.jpg' alt='B Logo' />
//             </div>
//             <div className='block md:hidden text-white w-18 h-10 z-20'>
//                 <img className='w-[100%] h-[100%] object-fill' src='/b.jpeg' alt='Logo' />
//             </div>
// </a> */}
//           <ul
//             className={`hidden text-white font-medium md:flex gap-12 md:items-center mr-4`}
//           >
// {/*          
//             <li
//               onMouseEnter={() => setShowSolution(true)}
//               onMouseLeave={() => setShowSolution(false)}
//               className="relative cursor-pointer flex items-center gap-1 text-black"
//             >
//               CREDIT CARDS {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
//               {showSolution && (
//                 <div className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[950px] shadow-lg py-6 border left-0">
//                   <div className="grid grid-cols-4 gap-6 p-6">
//                     <div className="col-span-1 border-r pr-4">
//                       {Object.keys(solutionsData).map((section) => (
//                         <div
//                           key={section}
//                           onMouseEnter={() => setActiveSection(section)}
//                           className={`px-4 py-2 cursor-pointer rounded-lg transition-all flex items-center gap-2 ${
//                             activeSection === section
//                               // ? "bg-blue-50 text-blue-600"
//                               // : "hover:bg-gray-50"
//                               ? "bg-[#217dd3] text-white shadow-md"
//                   : "hover:bg-gray-100 hover:text-[#217dd3]"
//                           }`}
//                         >
//                           {solutionsData[section].icon}
//                           {section}
//                         </div>
//                       ))}
//                     </div>

//                     <div className="col-span-3 pl-4">
//                       {activeSection && (
//                         <div className="grid grid-cols-2 gap-4">
//                           {solutionsData[activeSection].items.map((item) => (
//                             <a
//                               key={item.name}
//                               href={item.path}
//                               className="p-3 rounded-lg hover:bg-gray-50  hover:shadow-md   transition-all"
//                             >
//                               <div className="font-medium textColor flex items-center  gap-2">
//                                 {item.icon}
//                                 {item.name}
//                               </div>
//                               <p className="text-sm text-gray-500 mt-1 ml-6">
//                                 Explore our {item.name.toLowerCase()} 
//                               </p>
//                             </a>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </li> */}
//             <li
//   onMouseEnter={() => setShowSolution(true)}
//   onMouseLeave={() => setShowSolution(false)}
//   className="relative cursor-pointer flex items-center gap-1 text-black"
// >
// <Link to="/credit-card" >
//   CREDIT CARDS</Link> {showSolution ? <AiFillCaretUp /> : <AiFillCaretDown />}
//   {showSolution && (
//     <div className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[960px] shadow-lg py-6 border left-0">
//       <div className="grid grid-cols-5 gap-6 p-6">
//         <div className="col-span-1 border-r pr-4">
//           {Object.keys(solutionsData).map((section) => (
//             <div
//               key={section}
//               onMouseEnter={() => setActiveSection(section)}
//               className={`px-1 py-2 cursor-pointer rounded-lg transition-all flex items-center gap-2 ${
//                 activeSection === section
//                   ? "bg-[#217dd3] text-white shadow-md"
//                   : "hover:bg-gray-100 hover:text-[#217dd3]"
//               }`}
//             >
//               {solutionsData[section].icon}
//               {section}
//             </div>
//           ))}
//         </div>
        
//         <div className="col-span-4 pl-4">
//           {activeSection && (
//             <div className="grid grid-cols-4 gap-3"> 
//               {solutionsData[activeSection].items.map((item) => (
//                 <a
//                   key={item.name}
//                   href={item.path}
//                   className="p-2 rounded-lg hover:bg-gray-50 hover:shadow-md transition-all flex flex-col"
//                 >
//                   <div className="font-medium textColor flex items-center gap-2 text-sm">
//                     {item.icon}
//                     {item.name}
//                   </div>
//                   {/* <p className="text-xs text-gray-500 mt-1 ml-6">
//                     Explore our {item.name.toLowerCase().replace("bank", "").trim()} 
//                   </p> */}
//                 </a>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   )}
// </li>
//             <li
//               onMouseOver={() => setShowResources(true)}
//               onMouseLeave={() => setShowResources(false)}
//               className="relative cursor-pointer flex items-center gap-1 text-black"
//             >
//               INSURANCE{" "}
//               {showResources ? <AiFillCaretUp /> : <AiFillCaretDown />}
//               {showResources && (
//                 <>
//                   <div
//                     onMouseOver={() => setShowResources(true)}
//                     className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
//                   >
//                     <a href="/car_insurance">
//                       <p className="whitespace-nowrap font-medium text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaCarCrash />
//                       Car Insurance
//                       </p>
//                     </a>
//                     <a href="/bike_insurance">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaMotorcycle />
//                       Bike Insurance
//                       </p>
//                     </a>
//                     <a href="/travel_insurance">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaPlaneDeparture />
//                       Travel Insurance
//                       </p>
//                     </a>
//                     <a href="/health_insurance">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaHeartbeat />
//                       Health Insurance
//                       </p>
//                     </a>
//                     <a href="/termlife_insurance">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <BiUser />
//                       Term Life Insurance
//                       </p>
//                     </a>
                   
//                   </div>
//                 </>
//               )}
//             </li>
//             <li
//               onMouseOver={() => setShowResourcesNew(true)}
//               onMouseLeave={() => setShowResourcesNew(false)}
//               className="relative cursor-pointer flex items-center gap-1 text-black"
//             >
//               GET LOAN{" "}
//               {showResourcesNew ? <AiFillCaretUp /> : <AiFillCaretDown />}
//               {showResourcesNew && (
//                 <>
//                   <div
//                     onMouseOver={() => setShowResourcesNew(true)}
//                     className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
//                   >
//                     <a href="/car_loan">
//                       <p className="whitespace-nowrap font-medium text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaCarSide />
//                       Car Loan
//                       </p>
//                     </a>
//                     <a href="/gold_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaPiggyBank />
//                       Gold Loan
//                       </p>
//                     </a>
//                     <a href="/home_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaHome />
//                       Home Loan
//                       </p>
//                     </a>
//                     <a href="/personal_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaUserTie />
//                       Personal Loan
//                       </p>
//                     </a>
//                     <a href="/business_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaBriefcase />
//                       Business Loan
//                       </p>
//                     </a>
                    
//                     <a href="/education_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaBookOpen  />
//                       Education Loan
//                       </p>
//                     </a>
//                     <a href="/two_wheeler_loan">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <FaMotorcycle />

//                       TwoWheeler Loan
//                       </p>
//                     </a>
                   
//                   </div>
//                 </>
//               )}
//             </li>
//             <a href="/demat">
//               <li className="relative cursor-pointer text-black"> DEMAT</li>
//             </a>
//             <li
//               onMouseOver={() => setShowBlogs(true)}
//               onMouseLeave={() => setShowBlogs(false)}
//               className="relative cursor-pointer flex items-center gap-1 text-black"
//             >
//               RESOURCES {showBlogs ? <AiFillCaretUp /> : <AiFillCaretDown />}
//               {showBlogs && (
//                 <>
//                   <div
//                     onMouseOver={() => setShowBlogs(true)}
//                     className="absolute z-50 bottom-0 translate-y-[100%] bg-white rounded-lg w-[250px] shadow-lg py-3 border"
//                   >
//                     <a href="/blog_page">
//                       <p className="whitespace-nowrap font-medium  text-black py-4 hover:bg-[#217dd3] hover:text-white px-5 hover:shadow-md flex items-center gap-3">
//                       <BiBookContent/>
//                         Blogs
//                       </p>
//                     </a>
//                   </div>
//                 </>
//               )}
//             </li>
           
            
//             <a href="/financial-tools-calculators">
//               <li className="relative cursor-pointer text-black"> TOOLS
//               </li>
//             </a>
//             <a href="/contact-us">
//               <li className="relative cursor-pointer text-black">CONTACT US</li>
//             </a>
//           </ul>

//           <div className="flex items-center md:hidden">
//             {isNav ? (
//               <RxCross2
//                 className="text-black text-2xl cursor-pointer"
//                 onClick={() => setIsNav((prev) => !prev)}
//               />
//             ) : (
//               <GiHamburgerMenu
//                 onClick={() => setIsNav((prev) => !prev)}
//                 className="text-black text-2xl cursor-pointer"
//               />
//             )}
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default NavBarNew;

// PolicyBazaarNavbar.jsx
// import { useState, useRef, useEffect } from 'react';
// import { ChevronDown, Phone } from 'lucide-react';

// const PolicyBazaarNavbar = () => {
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [isScrolled, setIsScrolled] = useState(false);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     const handleScroll = () => {
//       if (window.scrollY > 10) {
//         setIsScrolled(true);
//       } else {
//         setIsScrolled(false);
//       }
//     };

//     window.addEventListener('scroll', handleScroll);
//     return () => window.removeEventListener('scroll', handleScroll);
//   }, []);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setActiveDropdown(null);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const toggleDropdown = (dropdown) => {
//     setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
//   };

//   const navbarClasses = `sticky top-0 z-50 w-full transition-all duration-300 ${isScrolled ? 'shadow-md bg-white' : 'bg-white'}`;

//   const insuranceProducts = [
//     {
//       category: 'Term Insurance',
//       links: [
//         'Life Insurance',
//         'List of Term Insurance Plan',
//         'Term Insurance for NRI',
//         'What is Term Insurance',
//         '1 Crore Term Insurance',
//         'Term Insurance Calculator',
//         'Dedicated Claim Assistance',
//         'Term Insurance for Women',
//         'Term Insurance for HNI',
//         'Term Insurance Return of Premium'
//       ]
//     },
//     {
//       category: 'Investment Plans',
//       links: [
//         'Investment Plans with High Returns',
//         'Market Linked Investment Plans (ULIP)',
//         'Investment Plans for NRIs',
//         'SIP Calculator',
//         'Capital Guarantee Plans',
//         'Child Plans',
//         'Pension Plans',
//         'Guaranteed Return Plans',
//         'Tax Saving Investments',
//         'SIP (Systematic Investment Plan)',
//         'Endowment Policy',
//         'LIC',
//         'Money Back Policy',
//         'Annuity Plans',
//         'Income Tax Calculator'
//       ]
//     },
//     {
//       category: 'Health Insurance',
//       links: [
//         'Book Free Home Visit',
//         'Family Health Insurance',
//         'Senior Citizen Health Insurance',
//         'Health Insurance for Parents',
//         'Maternity Insurance',
//         'Health Insurance Portability',
//         'OPD Cover In Health Insurance',
//         'Mediclaim Policy',
//         'Critical Illness Insurance',
//         'Health Insurance Calculator',
//         'Health Insurance Companies',
//         'Types of Health Insurance',
//         'Health Insurance for NRIs'
//       ]
//     },
//     {
//       category: 'Car Insurance',
//       links: [
//         'Motor Insurance',
//         'Bike Insurance',
//         'Zero Dep Car Insurance',
//         'Third Party Insurance',
//         'Third Party Bike Insurance',
//         'Car Insurance Calculator',
//         'Bike Insurance Calculator',
//         'Car Insurance Companies',
//         'Pay As You Drive Insurance',
//         'Commercial Vehicle Insurance',
//         'Electric Car Insurance',
//         'E-Bike Insurance',
//         'IDV Calculator',
//         'Comprehensive Insurance',
//         'Car Valuation'
//       ]
//     },
//     {
//       category: 'Other Insurance',
//       links: [
//         'Travel Insurance',
//         'Group Health Insurance',
//         'Marine Insurance',
//         'Workmen Compensation Policy'
//       ]
//     }
//   ];

//   const renewalOptions = [
//     { icon: '☂️', text: 'Term Life Renewal' },
//     { icon: '💰', text: 'Investment Renewal' },
//     { icon: '❤️', text: 'Health Renewal' },
//     { icon: '🚗', text: 'Motor Renewal' },
//     { icon: '🏍️', text: 'Two Wheeler Renewal' },
//     { icon: '🏠', text: 'Home Insurance' }
//   ];

//   return (
//     <nav className={navbarClasses} ref={dropdownRef}>
//       <div className="container mx-auto px-4">
//         <div className="flex items-center justify-between h-16">
//           {/* Logo */}
//           <div className="flex items-center">
//             <div className="flex-shrink-0">
//               <div className="flex flex-col">
//                 <h1 className="text-blue-500 font-bold text-2xl">
//                   policy<span className="text-black">bazaar</span>
//                   <span className="bg-blue-500 text-white text-xs rounded-full px-1 align-top">PB</span>
//                 </h1>
//                 <span className="bg-gray-800 text-white text-xs px-2 italic">HAR FAMILY HOGI INSURED</span>
//               </div>
//             </div>
//           </div>

//           {/* Navigation Links - Desktop */}
//           <div className="hidden md:flex md:items-center md:space-x-4">
//             {/* Insurance Products Dropdown */}
//             <div className="relative">
//               <button 
//                 onClick={() => toggleDropdown('products')}
//                 className="flex items-center text-gray-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100"
//               >
//                 Insurance Products
//                 <ChevronDown size={16} className={`ml-1 transform transition-transform ${activeDropdown === 'products' ? 'rotate-180' : ''}`} />
//               </button>

//               {activeDropdown === 'products' && (
//                 <div className="absolute left-0 mt-2 p-4 bg-white shadow-lg rounded-md w-full max-w-screen-xl" style={{ maxHeight: '70vh', overflowY: 'auto', width: '900px' }}>
//                   <div className="grid grid-cols-5 gap-6">
//                     {insuranceProducts.map((category, idx) => (
//                       <div key={idx} className="space-y-2">
//                         <h3 className="text-blue-500 font-medium mb-3">{category.category}</h3>
//                         <ul className="space-y-2">
//                           {category.links.map((link, linkIdx) => (
//                             <li key={linkIdx}>
//                               <a href="#" className="text-gray-600 hover:text-blue-500 text-sm">
//                                 {link}
//                               </a>
//                             </li>
//                           ))}
//                         </ul>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Renew Your Policy Dropdown */}
//             <div className="relative">
//               <button 
//                 onClick={() => toggleDropdown('renew')}
//                 className="flex items-center text-gray-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100"
//               >
//                 Renew Your Policy
//                 <ChevronDown size={16} className={`ml-1 transform transition-transform ${activeDropdown === 'renew' ? 'rotate-180' : ''}`} />
//               </button>

//               {activeDropdown === 'renew' && (
//                 <div className="absolute right-0 mt-2 w-64 bg-white shadow-lg rounded-md overflow-hidden">
//                   <div className="py-1">
//                     {renewalOptions.map((option, idx) => (
//                       <a 
//                         key={idx}
//                         href="#" 
//                         className="flex items-center px-4 py-3 hover:bg-gray-50 border-b border-gray-100 last:border-b-0"
//                       >
//                         <span className="mr-3">{option.icon}</span>
//                         <span className="text-gray-700">{option.text}</span>
//                       </a>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>

//             {/* Claim Dropdown */}
//             <div className="relative">
//               <button 
//                 onClick={() => toggleDropdown('claim')}
//                 className="flex items-center text-gray-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100"
//               >
//                 Claim
//                 <ChevronDown size={16} className={`ml-1 transform transition-transform ${activeDropdown === 'claim' ? 'rotate-180' : ''}`} />
//               </button>
              
//               {/* Dropdown content would go here */}
//             </div>

//             {/* Support Dropdown */}
//             <div className="relative">
//               <button 
//                 onClick={() => toggleDropdown('support')}
//                 className="flex items-center text-gray-700 px-3 py-2 rounded-md text-sm font-medium hover:bg-gray-100"
//               >
//                 Support
//                 <ChevronDown size={16} className={`ml-1 transform transition-transform ${activeDropdown === 'support' ? 'rotate-180' : ''}`} />
//               </button>
              
//               {/* Dropdown content would go here */}
//             </div>
//           </div>

//           {/* CTA Buttons */}
//           <div className="hidden md:flex md:items-center md:space-x-2">
//             <button className="flex items-center text-blue-500 border border-blue-500 rounded-md px-3 py-1 text-sm font-medium hover:bg-blue-50">
//               <Phone size={16} className="mr-2" />
//               Talk to Expert
//             </button>
//             <button className="bg-blue-500 text-white rounded-md px-3 py-1 text-sm font-medium hover:bg-blue-600">
//               Sign in
//             </button>
//           </div>

//           {/* Mobile Menu Button */}
//           <div className="md:hidden">
//             <button 
//               onClick={() => toggleDropdown('mobile-menu')}
//               className="text-gray-700 hover:bg-gray-100 p-2 rounded-md"
//             >
//               <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
//               </svg>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu */}
//       {activeDropdown === 'mobile-menu' && (
//         <div className="md:hidden bg-white border-t border-gray-200">
//           <div className="px-2 pt-2 pb-3 space-y-1">
//             <button 
//               onClick={() => toggleDropdown('mobile-products')}
//               className="flex justify-between items-center w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
//             >
//               Insurance Products
//               <ChevronDown size={16} className={`transform transition-transform ${activeDropdown === 'mobile-products' ? 'rotate-180' : ''}`} />
//             </button>
            
//             {activeDropdown === 'mobile-products' && (
//               <div className="pl-4 space-y-2">
//                 {insuranceProducts.map((category, idx) => (
//                   <div key={idx} className="mt-2">
//                     <h3 className="text-blue-500 font-medium">{category.category}</h3>
//                     <ul className="pl-4 mt-1 space-y-1">
//                       {category.links.slice(0, 5).map((link, linkIdx) => (
//                         <li key={linkIdx}>
//                           <a href="#" className="text-gray-600 hover:text-blue-500 text-sm">
//                             {link}
//                           </a>
//                         </li>
//                       ))}
//                       {category.links.length > 5 && (
//                         <li>
//                           <a href="#" className="text-blue-500 text-sm">
//                             More...
//                           </a>
//                         </li>
//                       )}
//                     </ul>
//                   </div>
//                 ))}
//               </div>
//             )}

//             <button 
//               onClick={() => toggleDropdown('mobile-renew')}
//               className="flex justify-between items-center w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
//             >
//               Renew Your Policy
//               <ChevronDown size={16} className={`transform transition-transform ${activeDropdown === 'mobile-renew' ? 'rotate-180' : ''}`} />
//             </button>
            
//             {activeDropdown === 'mobile-renew' && (
//               <div className="pl-4 space-y-2">
//                 {renewalOptions.map((option, idx) => (
//                   <a 
//                     key={idx}
//                     href="#" 
//                     className="flex items-center px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
//                   >
//                     <span className="mr-3">{option.icon}</span>
//                     <span>{option.text}</span>
//                   </a>
//                 ))}
//               </div>
//             )}

//             <button 
//               onClick={() => toggleDropdown('mobile-claim')}
//               className="flex justify-between items-center w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
//             >
//               Claim
//               <ChevronDown size={16} className={`transform transition-transform ${activeDropdown === 'mobile-claim' ? 'rotate-180' : ''}`} />
//             </button>

//             <button 
//               onClick={() => toggleDropdown('mobile-support')}
//               className="flex justify-between items-center w-full text-left px-3 py-2 text-gray-700 hover:bg-gray-100 rounded-md"
//             >
//               Support
//               <ChevronDown size={16} className={`transform transition-transform ${activeDropdown === 'mobile-support' ? 'rotate-180' : ''}`} />
//             </button>

//             <div className="pt-2 space-y-2">
//               <button className="flex items-center justify-center w-full text-blue-500 border border-blue-500 rounded-md px-3 py-2 text-sm font-medium hover:bg-blue-50">
//                 <Phone size={16} className="mr-2" />
//                 Talk to Expert
//               </button>
//               <button className="w-full bg-blue-500 text-white rounded-md px-3 py-2 text-sm font-medium hover:bg-blue-600">
//                 Sign in
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </nav>
//   );
// };

// export default PolicyBazaarNavbar;